<template>
  <v-app id="inspire" dark>
    <v-navigation-drawer

      clipped
      fixed
      :mini-variant="mini"
      v-model="drawer"
      :permanent="permanent"
      app
    >
      <v-list dense>
        <v-list-tile to="/">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile to="Roadmap">
          <v-list-tile-action>
            <v-icon>directions</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Roadmap</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="Settings">
          <v-list-tile-action>
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click.native.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>{{ mini ? 'chevron_right' : 'chevron_left' }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ mini ? 'Large' : 'Mini' }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"/>
      <v-toolbar-title>Construct Addon Manager</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container grid-list-xl>
        <v-layout justify-center align-center>

          <transition name="slide-x-reverse-transition" mode="out-in">
            <router-view/>
          </transition>

        </v-layout>
      </v-container>

      <v-speed-dial v-if="this.$route.name === 'home'" fab fixed bottom right direction="top">
        <v-btn slot="activator" color="blue darken-2" dark fab to="upload">
          <v-icon>backup</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-content>
    <v-footer app fixed class="pa-3">
      <v-spacer/>
      <span>&copy; {{ new Date().getFullYear() }} <a href="https://armaldio.xyz">Armaldio</a> ALL RIGHTS RESERVED</span>
    </v-footer>

    <AddonDetails/>

  </v-app>

</template>

<script>
  import AddonDetails from './components/AddonDetails';

  export default {
    components: {AddonDetails},
    name: 'app',
    computed: {},
    methods: {
    },
    data: () => ({
      drawer: false,
      mini: true,
      permanent: false,
      fab: false,

      transition: 'scale-transition'
    })
  };
</script>

<style>
  html {
    /*overflow-y: hidden;*/
  }

  .speed-dial {
    bottom: 64px !important;
    z-index: 4;
  }

  .container.grid-list-md .layout .flex {
    padding-top: 24px
  }

  * {
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue